export default __webpack_public_path__ + "static/media/ENG.b072788a.svg";